import React, { useState, useCallback } from 'react';

/**
 * Drop-in replacement for <img> with an off-white placeholder.
 * Pass the same className you'd give the <img> — it goes on the wrapper
 * so existing sizing CSS still applies. The inner <img> fills it.
 */
const PlaceholderImage = ({ className = '', onLoad: externalOnLoad, alt = '', ...props }) => {
  const [loaded, setLoaded] = useState(false);

  const handleLoad = useCallback(
    (e) => {
      setLoaded(true);
      externalOnLoad?.(e);
    },
    [externalOnLoad]
  );

  return (
    <div className={`media-placeholder ${loaded ? 'media-placeholder--loaded' : ''} ${className}`}>
      <img {...props} alt={alt} onLoad={handleLoad} />
    </div>
  );
};

/**
 * Drop-in replacement for <video> with an off-white placeholder.
 * The placeholder shows until the video has enough data to display.
 */
const PlaceholderVideo = ({ className = '', children, ...props }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className={`media-placeholder ${loaded ? 'media-placeholder--loaded' : ''} ${className}`}>
      <video {...props} onLoadedData={() => setLoaded(true)}>
        {children}
      </video>
    </div>
  );
};

export { PlaceholderImage, PlaceholderVideo };
